import { GeoLocation, ProjectDataModel } from 'api/client.model'
import { GenerateOptions } from './generateOptions.model'

export const generateOptions = (): GenerateOptions => {
  const generateProjectOptions = (
    projects: ProjectDataModel[],
    projectId?: string
  ) => {
    let finalProjects = projects
    if (projectId) {
      finalProjects = projects.filter((item) => item.id === projectId)
    }
    return finalProjects.map((item) => ({
      label: item.name || `Project - ${item.id}`,
      value: item.id
    }))
  }

  const generateSiteOptions = (
    projects: ProjectDataModel[],
    projectId: string
  ) => {
    const project = projects.find((item) => item.id === projectId)
    if (project && project.sites && project.sites.length > 0) {
      return project.sites.map((item) => ({
        label: item.name || item.location || `Site - ${item.id}`,
        value: item.id
      }))
    }
    return []
  }

  const generateStateOptions = (geoLocations: GeoLocation[]) => {
    const states = geoLocations.map((item) => ({
      label: item.state,
      value: item.state
    }))
    return states
      .filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (item) => item.label === value.label && item.value === value.value
          )
      )
      .sort((a, b) => {
        if (a.label < b.label) {
          return -1
        }
        if (a.label > b.label) {
          return 1
        }
        return 0
      })
  }

  return {
    generateProjectOptions,
    generateSiteOptions,
    generateStateOptions
  }
}
